import { useMediaQuery, useTheme } from '@mui/material';
import { concatBasePathWithPath } from 'common/router/utils';
import { type PropsWithChildren } from 'react';
import { useLocation } from 'react-router';

import DonationsPlusLogo from '../common-flow/components/donations-plus-logo/DonationsPlusLogo';
import NavigationBar from '../common-flow/components/navigation-bar/NavigationBar';
import { vettingPath } from '../common-flow/entries/path';

import { StyledContainer, StyledCenterWrapper, StyledMobileFooter } from './StyledComponents';

export const OnboardingLayout = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('md'));

  const isGetStartedScreen = [
    concatBasePathWithPath(vettingPath.getStartedPath, vettingPath.basePath),
  ].includes(pathname);

  const isReviewScreen = [
    concatBasePathWithPath(vettingPath.reviewDetailsPath, vettingPath.basePath),
  ].includes(pathname);

  const showNavigationBar = !isGetStartedScreen && !isReviewScreen;

  return (
    <StyledContainer>
      {showNavigationBar ? <NavigationBar isMobile={isMobile} /> : null}
      <StyledCenterWrapper sx={{ px: isGetStartedScreen ? 0 : 2 }}>{children}</StyledCenterWrapper>
      {isMobile && showNavigationBar ? (
        <StyledMobileFooter>
          <DonationsPlusLogo isDarkLogo />
        </StyledMobileFooter>
      ) : null}
    </StyledContainer>
  );
};
